<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-btn(icon @click="showDialog = false")
        v-icon mdi-chevron-left
      v-spacer
      .text-xl.font-bold.mr-10 Create reject reason
      v-spacer
    v-divider
    v-card-text.primary--text
      .mt-8.mb-4.text-md.font-semibold How do you want your salesperson record reject status?
      .text-sm Choose one and click "Confirm"
      v-item-group.pb-10(mandatory @change="onOptionChanged" flat)
        div(v-for="option in options" :key="option.id")
          v-item(v-slot="{ active, toggle }")
            .round-xl.mt-4(:class="active ? 'border-item-active' : 'border-item-inactive'"  @click="toggle" flat rounded="lg")
              .text-md.font-medium.mb-1 {{ option.title }}
              .text-sm.neutral500--text {{ option.description }}
    v-divider
    v-card-actions.py-4.pr-6
      v-btn.button-md.primary400--text.underline.py-0(@click="showDialog = false" text) {{ $t('back') }}
      v-spacer
      v-btn.button-md(@click="next" color="primary" depressed) {{ $t('next') }}
    .dialogs
      add-reject-reason-dialog(v-if="showAddRejectReasonDialog" :open.sync="showAddRejectReasonDialog")
</template>

<script>
import AddRejectReasonDialog from './AddRejectReasonDialog.vue'

export default {
  name: 'CreateReject',
  components: { AddRejectReasonDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedIndex: 0,
    options: [
      { 
        id: 'add', 
        title: 'Add reject reason', 
        description: 'This will help salespersons to categorize rejection better.' 
      },
      { 
        id: 'no_add', 
        title: 'Do not add reject reason', 
        description: 'Salesperson will type manually each time the change status to reject' 
      }
    ],
    showAddRejectReasonDialog: false
  }),
  computed: {
    showDialog: {
      get() { return this.open },
      set(newValue) { this.$emit('update:open', newValue) }
    }
  },
  methods: {
    onOptionChanged(i) {
      this.selectedIndex = i
    },
    next() {
      const option = this.options[this.selectedIndex]
      if (option.id === 'add') {
        this.showAddRejectReasonDialog = true
      }
    }
  }
}
</script>
